import { render, staticRenderFns } from "./ContainerWizard.vue?vue&type=template&id=708fecac&"
import script from "./ContainerWizard.vue?vue&type=script&lang=js&"
export * from "./ContainerWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports